/** In-memory Web3 session — must not live in Redux (non-serializable). */
const getStore = () => {
  if (typeof window !== 'undefined') {
    if (!window.__atsNonCustodialSession) {
      window.__atsNonCustodialSession = { web3: null, rpcBusy: false };
    }
    return window.__atsNonCustodialSession;
  }

  if (!getStore.moduleStore) {
    getStore.moduleStore = { web3: null, rpcBusy: false };
  }
  return getStore.moduleStore;
};

export const setNonCustodialWeb3Session = (web3) => {
  getStore().web3 = web3 ?? null;
};

export const getNonCustodialWeb3Session = () => getStore().web3;

export const clearNonCustodialWeb3Session = () => {
  const store = getStore();
  store.web3 = null;
  store.rpcBusy = false;
};

/** Blocks balance/allowance reads while MetaMask is opening a transaction popup. */
export const setNonCustodialRpcBusy = (value) => {
  getStore().rpcBusy = Boolean(value);
};

export const isNonCustodialRpcBusy = () => getStore().rpcBusy;
